import React from 'react';
import { useDataContext } from "../../../../hooks/useDataContext";
import DayCell from "./DayCell";

/**
 * Renders a row representing a user with cells for each day.
 * @param {Object} props - The props for the UserRow component.
 * @param {Object} props.user - The user object containing information to be displayed.
 * @returns {JSX.Element} A row representing a user.
 */
const UserRow = ({ user, hideTimeline = false, dates = null, columnWidth = null }) => {
    // Use prop dates if provided, otherwise fallback to context
    const contextData = useDataContext();
    const datesToUse = dates || contextData?.dates;
    
    if (!datesToUse || !datesToUse.length) {
        return null;
    }
    
    // Render a cell for each day
    return (
        <>
            {datesToUse.map((day, index) => {
                return (
                    <DayCell key={index} day={day} user={user} hideTimeline={hideTimeline} columnWidth={columnWidth} />
                );
            })}
        </>
    );
}



export default UserRow;
